/* eslint-disable max-len */
// ==============================================
// ==================Import======================
// ==============================================

// ===================Dependancies================
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';

// ===================Librairie joyride================
import Joyride, { STATUS } from 'react-joyride';

// ===================Actions=====================
import {
  saveStationShortData,
  SaveTimeSeries,
  setFetchDoiAndLicence,
  setFetchImages,
  setFullDataAvailable,
  setSaveFullOneStationData,
} from '../../actions/metadata';
import { fetchFullOneStationData } from '../../actions/dataAPI';
import { setOpenTour } from '../../actions/site';

// ===================Components==================
import MapOnePoint from './MapOnePoint';
import Spinner2 from '../Spinner2';
import Spinner from '../Spinner';
import Description from './Description';
import Instrumentation from './Instrumentation';
import Collocation from './Collocation';
import Data from './Data';
import Associated from './Associated';
import Quality from './Quality';
import MenuButton from '../MenuButton';
import ModalExportQuery from '../ModalExportQuery';
import DOI from './DOI';
import CarouselImages from './CarouselImages';
import CarouselTimeSeries from './CarouselTimeSeries';

// ==================Style&IMG===================
import './style.scss';
import NotFound from './NotFound';
import NoMarkerInData from './NoMarkerInData';
import { globalConfig } from '../../configuration/config';

function Metadata() {
  // ================HOOK==========================
  const dispatch = useDispatch();
  const stations = useSelector((state) => state.dataAPI.stations.list);
  const stationShortData = useSelector((state) => state.metadata.data.stationShortData);
  const stationFullData = useSelector((state) => state.metadata.data.stationFullData);
  const saveFullData = useSelector((state) => state.metadata.data.saveFullData);
  const markersColors = useSelector((state) => state.site.markersColors);
  const fullDataAvailable = useSelector((state) => state.metadata.data.fullDataAvailable);
  const loadingFullData = useSelector((state) => state.metadata.data.loadingFullData);
  const openTour = useSelector((state) => state.site.joyride.openTour);
  const slug = useParams();
  const mapResults = useSelector((state) => state.site.map.mapResults);
  const displayImage = useSelector((state) => state.metadata.data.dataDoi.displayImages);
  const dataAPI = useSelector((state) => state.dataAPI.stations.list.data);

  // static timeseries Array
  const timeSeriesArray = [
    'UGA-CNRS',
    'INGV',
    'ROB-EUREF',
    'SGO-EPND',
  ];

  const timeSeriesData = [];

  // Static definition of joyride tour of the interface
  const steps = [
    {
      target: '#navmenu',
      content: <p><strong>Step 1: </strong>Navigation on the different menu</p>,
      disableBeacon: true,
    },
    {
      target: '.btn-download',
      content: <p><strong>Step 2: </strong>Download the stations metadata in different format</p>,
      disableBeacon: true,
    },
    {
      target: '.btn-export',
      content:
  <p><strong>Step 3: </strong>
    Export the query for the command line tool and API request format
  </p>,
      disableBeacon: true,
    },
  ];

  // ==============functions===============
  // function to color the marker in map
  function colorOneMarker() {
    const color = markersColors;
    color.forEach((elemColor) => {
      const colorOfMarker = document.getElementsByClassName(elemColor.name);
      if (colorOfMarker.length !== 0) {
        colorOfMarker[0].style.filter = `invert(${elemColor.invert}%) sepia(97%) saturate(1812%) hue-rotate(${elemColor.rotate}deg) brightness(94%) contrast(101%)`;
        if (elemColor.borderColor !== undefined) {
          colorOfMarker[0].style.border = `2px solid #${elemColor.borderColor}`;
          colorOfMarker[0].style.borderRadius = '10px';
        }
      }
    });
  }

  // joyride handler
  const handleJoyrideCallback = (data) => {
    const { status } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

    if (finishedStatuses.includes(status)) {
      dispatch(setOpenTour(false));
    }
  };

  let station = [];

  // ==============UseEffect=============
  // when launching the page, fetch data for Doi images and licenses
  useEffect(
    () => {
      if (stationShortData === undefined) {
        window.location.href = `${window.origin}/#/404`;
      }
      dispatch(setFetchDoiAndLicence(slug.slug.substring(7)));
      dispatch(setFetchImages(slug.slug.substring(7)));
      const pathname = window.location.href;
      const prevUrl = localStorage.getItem('pageUrl');
      if (prevUrl === null) {
        localStorage.setItem('pageUrl', JSON.stringify(pathname));
      }
      if (document.getElementsByClassName('app-404').length !== 0) {
        window.location.reload();
      }
    },
    [],
  );
  useEffect(() => {
    if (Object.keys(stationShortData).length > 0) {
      if (slug.slug.substring(7) !== stationShortData.marker_long_name) {
        window.location.reload();
      }
    }
  });
  // when state stationShortData value change add time series image in array to display it
  useEffect(
    () => {
      for (let i = 0; i < timeSeriesArray.length; i += 1) {
        if (stationShortData.marker_long_name !== undefined) {
          timeSeriesData.push({
            image: `https://gnssproducts.epos.ubi.pt/GlassFramework/webresources/products/time-series-plot/${timeSeriesArray[i]}/${stationShortData.marker_long_name}`,
            text: timeSeriesArray[i],
            id: i,
            marker: stationShortData.marker_long_name,
          });
        }
      }
      dispatch(SaveTimeSeries(timeSeriesData));
    },
    [stationShortData],
  );

  //  when map result state value change search station with same slug name
  // save it in state
  useEffect(
    () => {
      if (mapResults) {
        station = stations.data.find(
          (itemStation) => itemStation.marker_long_name === slug.slug.substring(7),
        );
        if (station !== undefined) {
          dispatch(saveStationShortData(station));
        }
        else {
          dispatch(setFullDataAvailable(false));
        }
      }
    },
    [mapResults],
  );

  // when stationShortData state value change fetch the data of new station
  useEffect(
    () => {
      dispatch(fetchFullOneStationData(stationShortData.marker_long_name, globalConfig.config.REACT_APP_NODE_URL, globalConfig.config.REACT_APP_GLASS_API));
    },
    [stationShortData],
  );

  // when fetch is done cut the spinner and color the marker
  useEffect(
    () => {
      if (stationFullData.length !== 0) {
        dispatch(setSaveFullOneStationData(true));
        setTimeout(() => {
          colorOneMarker();
        }, 10);
      }
    },
    [stationFullData],
  );

  useEffect(() => {
    if (stationShortData.length === 0 && dataAPI !== undefined) {
      const findMarker = dataAPI.find((el) => el.marker_long_name === slug.slug.substring(7));
      if (findMarker !== undefined) {
        window.location.reload();
      }
    }
  }, [slug.slug]);

  return (
    <>
      <Joyride
        run={openTour}
        steps={steps}
        callback={handleJoyrideCallback}
        continuous
        hideCloseButton
        scrollToFirstStep
        showProgress
        showSkipButton
        styles={{
          options: {
            zIndex: 10000,
            primaryColor: '#048b9a',
          },
        }}
      />
      <div className="row content">
        <MenuButton />
        <div className="col-sm-3">
          <div id="navmenu">
            <ul>
              <li>
                <Link to={`/metadata/marker=${slug.slug.substring(7)}/description`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-info-circle-fill" viewBox="0 0 16 16">
                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
                  </svg> Station / Monument
                </Link>
              </li>
              <li>
                <Link to={`/metadata/marker=${slug.slug.substring(7)}/instrumentation`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-card-list" viewBox="0 0 16 16">
                    <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z" />
                    <path d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z" />
                  </svg> Instrumentation
                </Link>
              </li>
              <li>
                <Link to={`/metadata/marker=${slug.slug.substring(7)}/collocation`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z" />
                    <path fillRule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z" />
                  </svg> Collocation / Conditions
                </Link>
              </li>
              <li>
                <Link to={`/metadata/marker=${slug.slug.substring(7)}/associated`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-files" viewBox="0 0 16 16">
                    <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z" />
                  </svg> Associated files
                </Link>
              </li>
              <li>
                <Link to={`/metadata/marker=${slug.slug.substring(7)}/data`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-calendar3" viewBox="0 0 16 16">
                    <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z" />
                    <path d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
                  </svg> Data availability
                </Link>
              </li>
              <li>
                <Link to={`/metadata/marker=${slug.slug.substring(7)}/quality`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-calendar3" viewBox="0 0 16 16">
                    <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z" />
                    <path d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
                  </svg> Quality Check
                </Link>
              </li>
              <li>
                <Link to={`/metadata/marker=${slug.slug.substring(7)}/DOI`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-calendar3" viewBox="0 0 16 16">
                    <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z" />
                    <path d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
                  </svg> DOI & Licence
                </Link>
              </li>
            </ul>
          </div>
          {displayImage === false && (
            <Spinner />
          )}
          <div>
            <CarouselImages />
            <CarouselTimeSeries />
          </div>
        </div>
        <div className="col-sm-9">
          <div className="metadata__map--container">
            {(!saveFullData && loadingFullData) && <Spinner2 />}
            {(saveFullData)
            && (
            <>
              <div className="metadata__map--container--information">
                <div><h2><span className="metadata__map--container--information--name--title">{stationFullData[0].marker_long_name}</span></h2></div>
                <div>
                  <p><span className="metadata__map--container--information--name--siteName">{stationFullData[0].name}</span></p>
                  <p><span className="metadata__map--container--information--name">Latitude : </span>{stationFullData[0].location.coordinates.lat}</p>
                  <p><span className="metadata__map--container--information--name">Longitude : </span>{stationFullData[0].location.coordinates.lon}</p>
                  <p><span className="metadata__map--container--information--name">Altitude : </span>{stationFullData[0].location.coordinates.altitude}</p>
                </div>
                <div><p><span className="metadata__map--container--information--name">Status : </span><span id="stationActivated">{(stationFullData[0].date_to === null) && 'Active'}</span> <span id="stationDeactivated">{(stationFullData[0].date_to !== null) && 'Inactive'}</span></p></div>
                <div><p><span className="metadata__map--container--information--name">Type : </span>{stationFullData[0].station_type.name}</p></div>
              </div>
              <div id="metadata--mapId">
                <MapOnePoint {...stationShortData} id="metadata--mapId--map" />
              </div>
            </>
            )}
            {(!fullDataAvailable) && <NoMarkerInData />}
            {/* {(fullDataAvailable) && <NotFound />} */}
          </div>

          <div className="metadata__description--container">
            {(saveFullData && slug.typeInfo === 'description')
            && <Description {...stationFullData[0]} description2={stationFullData[0].description} /> }
            {(saveFullData && slug.typeInfo === 'instrumentation')
            && <Instrumentation fullData={stationFullData} /> }
            {(saveFullData && slug.typeInfo === 'collocation')
            && <Collocation fullData={stationFullData} />}
            {(saveFullData && slug.typeInfo === 'associated')
            && <Associated fullData={stationFullData} />}
            {(saveFullData && slug.typeInfo === 'data')
            && <Data />}
            {(saveFullData && slug.typeInfo === 'quality')
            && <Quality />}
            {(saveFullData && slug.typeInfo === 'DOI')
            && <DOI />}
            {(saveFullData && slug.typeInfo !== 'DOI' && slug.typeInfo !== 'description' && slug.typeInfo !== 'instrumentation' && slug.typeInfo !== 'collocation' && slug.typeInfo !== 'associated' && slug.typeInfo !== 'data' && slug.typeInfo !== 'quality')
            && <NotFound />}
          </div>
        </div>
        <ModalExportQuery />
      </div>
    </>
  );
}
export default Metadata;
